(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-quote-builder"] && !Shopify.designMode) return;
  try {
    
  class KpnQuoteBuilder {
    constructor(section) {
      this.section = section;
      this.step = 0;
      this.tabs = [...section.querySelectorAll('[data-step]')];
      this.panels = [...section.querySelectorAll('[data-panel]')];
      this.prev = section.querySelector('[data-prev]');
      this.next = section.querySelector('[data-next]');
      this.outputs = {};
      section.querySelectorAll('[data-output]').forEach((node) => {
        this.outputs[node.dataset.output] = node;
      });
      this.materialData = {
        corrugated: { label: 'Corrugated Paper Pulp', low: 1700, high: 1600 },
        bamboo: { label: 'Bamboo Pulp Board', low: 3100, high: 3000 },
        wood: { label: 'Virgin Wood Pulp Board', low: 3100, high: 3000 },
        bagasse: { label: 'Bagasse Pulp', low: 3100, high: 3000 }
      };
      this.processData = {
        forming_hot: { label: 'Forming + Hot Press', hot: true, trim: false },
        forming_trim: { label: 'Forming + Trimming', hot: false, trim: true },
        forming_hot_trim: { label: 'Forming + Hot Press + Trimming', hot: true, trim: true }
      };
      this.formingMold = { '600x800': 1000, '800x1200': 1550 };
      this.hotPressMold = {
        '600x800': { '400x600': 800, '600x800': 1200 },
        '800x1200': { '600x800': 1500, '800x1200': 2300 }
      };
      this.trimmingDie = { '600x800': 500, '800x1200': 800 };
      this.bind();
      this.show(0);
      this.calculate();
    }

    bind() {
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.show(Number(tab.dataset.step))));
      this.prev.addEventListener('click', () => this.show(this.step - 1));
      this.next.addEventListener('click', () => {
        if (this.step < 3) {
          this.show(this.step + 1);
        } else {
          const target = document.querySelector('.shopify-app-block, #ContactForm');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      this.section.addEventListener('input', () => this.calculate());
      this.section.addEventListener('change', () => this.calculate());
    }

    show(index) {
      this.step = Math.max(0, Math.min(3, index));
      this.tabs.forEach((tab, itemIndex) => {
        const active = itemIndex === this.step;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panels.forEach((panel, itemIndex) => panel.classList.toggle('is-active', itemIndex === this.step));
      this.prev.style.visibility = this.step === 0 ? 'hidden' : 'visible';
      this.next.textContent = this.step === 3 ? 'Use Estimate In Form' : 'Next';
    }

    selected(prefix) {
      return this.section.querySelector(`input[name^="${prefix}_"]:checked`)?.value;
    }

    input(name) {
      return this.section.querySelector(`[data-input="${name}"]`)?.value;
    }

    formatMoldSize(size) {
      return `${size.replace('x', ' x ')} mm`;
    }

    updateHotPressOptions() {
      const system = this.input('formingSystem') || '800x1200';
      const select = this.section.querySelector('[data-input="hotPressMold"]');
      if (!select) return;
      const current = select.value;
      select.innerHTML = Object.keys(this.hotPressMold[system]).map((size) => `<option value="${size}">${this.formatMoldSize(size)}</option>`).join('');
      if (this.hotPressMold[system][current]) select.value = current;
    }

    money(value) {
      return `USD ${Math.round(value).toLocaleString()}`;
    }

    unit(value) {
      return `USD ${value.toFixed(3)}`;
    }

    hasValidProductInputs(values) {
      return values.every((value) => value !== '' && Number.isFinite(Number(value)) && Number(value) > 0);
    }

    resetEstimate() {
      this.outputs.unit.textContent = '—';
      this.outputs.toolingHero.textContent = '—';
      this.outputs.tonnage.textContent = '—';
      this.outputs.productAmount.textContent = '—';
      this.outputs.projectAmount.textContent = '—';
      this.outputs.details.innerHTML = '';
    }

    calculate() {
      this.updateHotPressOptions();
      const materialKey = this.selected('material') || 'corrugated';
      const processKey = this.selected('process') || 'forming_hot';
      const material = this.materialData[materialKey];
      const process = this.processData[processKey];
      const system = this.input('formingSystem') || '800x1200';
      const hotSize = this.input('hotPressMold') || Object.keys(this.hotPressMold[system])[0];
      const structure = this.input('trayStructure') || 'single';
      const productInputs = ['length', 'width', 'height', 'unitWeight', 'quantity'].map((name) => this.input(name) || '');
      if (!this.hasValidProductInputs(productInputs)) {
        this.resetEstimate();
        return;
      }
      const [length, width, height, unitWeight, quantity] = productInputs.map(Number);
      const totalWeightKg = unitWeight * quantity / 1000;
      const totalTonnage = unitWeight * quantity / 1000000;
      const materialPrice = totalTonnage >= 3 ? material.high : material.low;
      const materialCostPc = unitWeight / 1000000 * materialPrice;
      const estimatedUnitPrice = materialCostPc;
      const formingCost = this.formingMold[system];
      const hotCost = process.hot ? this.hotPressMold[system][hotSize] : 0;
      const trimCost = process.trim ? this.trimmingDie[system] : 0;
      const baseToolingCost = formingCost + hotCost + trimCost;
      const moldSetQuantity = structure === 'top_bottom' ? 2 : 1;
      const finalToolingCost = baseToolingCost * moldSetQuantity;
      const productAmount = estimatedUnitPrice * quantity;
      const projectAmount = productAmount + finalToolingCost;
      this.outputs.unit.textContent = `${this.unit(estimatedUnitPrice)} / pc`;
      this.outputs.toolingHero.textContent = this.money(finalToolingCost);
      this.outputs.tonnage.textContent = `${totalTonnage.toFixed(3)} tons`;
      this.outputs.productAmount.textContent = this.money(productAmount);
      this.outputs.projectAmount.textContent = this.money(projectAmount);
      const rows = [
        ['Selected Material', material.label],
        ['Selected Process', process.label],
        ['Selected Mold Option', `${this.formatMoldSize(system)} forming mold${process.hot ? ` + ${this.formatMoldSize(hotSize)} hot press mold` : ''}${process.trim ? ' + trimming die' : ''}`],
        ['Tray Structure', structure === 'top_bottom' ? 'Top + Bottom' : 'Single Tray'],
        ['Carton Inner Size', `${length} x ${width} x ${height} mm`],
        ['Unit Weight', `${unitWeight.toLocaleString()} g`],
        ['Quantity', `${quantity.toLocaleString()} pcs`],
        ['Total Weight', `${totalWeightKg.toLocaleString(undefined, { maximumFractionDigits: 2 })} kg`],
        ['Total Tonnage', `${totalTonnage.toFixed(3)} tons`],
        ['Material Cost / pc', `${this.unit(materialCostPc)} / pc`],
        ['Estimated Unit Price', `${this.unit(estimatedUnitPrice)} / pc`],
        ['Base Tooling Cost', this.money(baseToolingCost)],
        ['Mold Set Quantity', `${moldSetQuantity}`],
        ['Final Tooling Cost', this.money(finalToolingCost)],
        ['Estimated Total Product Amount', this.money(productAmount)],
        ['Estimated Total Project Amount', this.money(projectAmount)]
      ];
      this.outputs.details.innerHTML = rows.map(([label, value]) => `<div class="kpn-quote__detail"><span>${label}</span><strong>${value}</strong></div>`).join('');
    }
  }

  document.querySelectorAll('[data-kpn-quote]').forEach((section) => new KpnQuoteBuilder(section));

  } catch(e) { console.error(e); }
})();
})();
